import { Box, Button, styledComponent } from '@hermes/web-components'

export const CreateButton = styledComponent(Button)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  width: '100%',
  '&:disabled': {
    borderTop: `1px solid ${theme.palette.divider}`
  }
}))

export const CreateListContainer = styledComponent(Box)(({ theme }) => ({
  padding: '16px 24px 0',
  [theme.breakpoints.down('xs')]: {
    padding: '16px 16px 0'
  }
}))
